import { requestAndParse, requestSuccessful } from '../request';

const removeSlideFromStudy = async (studyId: number, slideId: number) => {
    const route = 'admin/remove-slide-from-study';
    const payload = { studyId, slideId };

    const response = await requestAndParse(route, payload, 'POST');

    const success = requestSuccessful(response);

    return success;
};

export default removeSlideFromStudy;
